import dayjs from "dayjs";
import { v4 as uuid } from "uuid";
import { OptionsToString, StringToOptions } from "../../libs/util/util_string";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export class Member {
  static END_POINT = "member";

  serno = 0;
  guid; //= uuid();

  project_guid = "";

  member_code = "";
  member_name = "";

  /** 此受檢者需要填寫的問卷清單的Guids: 範例: guid1﹋guid2﹋guid3 */
  spwk_uni_func_guids = "";
  getSpwkUniFuncGuids(): string[] {
    return StringToOptions(this.spwk_uni_func_guids);
  }
  setSpwkUniFuncGuids(guids: string[]): void {
    this.spwk_uni_func_guids = OptionsToString(guids);
  }

  /** 此受檢者需要填寫的問卷清單的Guids: 範例: guid1﹋guid2﹋guid3 */
  common_uni_func_guids = "";
  getCommonUniFuncGuids(): string[] {
    return StringToOptions(this.common_uni_func_guids);
  }
  setCommonUniFuncGuids(guids: string[]): void {
    this.common_uni_func_guids = OptionsToString(guids);
  }

  /** 受檢者.登入帳號 */
  member_id = "";

  /** 受檢者.登入密碼 */
  member_pw = "";

  /** 公司編號 */
  company_tax_id = "";

  /** 身分證 */
  sid = "";

  /** 性別 - 0:尚未設定、1:男、2:女 */
  gender = 0;

  /** 生日 */
  birth_date = "";

  /** 員工編號 */
  employee_id = "";

  /** 場次名稱 */
  project_name = "";

  /** 場次結案日期 */
  end_dt = "2999-01-01";

  /** 受檢者是否編輯過 - 特作問卷 */
  spwk_edit_at = "2999-01-01 00:00:00";
  IsSpwkEdit() {
    return !IsYear2999(this.spwk_edit_at);
  }

  /** 受檢者是否完成 - 特作問卷 */
  spwk_done_at = "2999-01-01 00:00:00";
  IsSpwkDone() {
    return !IsYear2999(this.spwk_done_at);
  }

  /** 受檢者是否完成 - 所有問卷 */
  all_quest_done_dt = "2999-01-01 00:00:00";

  /** his檔上傳時間 */
  his_upload_dt = "2999-01-01 00:00:00";

  IsHisUploadDone() {
    return !IsYear2999(this.his_upload_dt);
  }
  /** his檔上傳失敗訊息 */
  his_upload_err_msg = "";

  /** gov檔上傳時間 */
  gov_upload_dt = "2999-01-01 00:00:00";

  IsGovUploadDone() {
    return !IsYear2999(this.gov_upload_dt);
  }
  /** gov檔上傳失敗訊息 */
  gov_upload_err_msg = "";

  ui_upload_dt = "2999-01-01 00:00:00";

  IsUiUploadDone() {
    return !IsYear2999(this.ui_upload_dt);
  }
  /** gov檔上傳失敗訊息 */
  ui_upload_err_msg = "";
  IsAllQuestDone() {
    return !IsYear2999(this.all_quest_done_dt);
  }
  IsCommonFuncnull() {
    if (
      this.common_uni_func_guids == "" ||
      this.common_uni_func_guids == null
    ) {
      return true;
    } else {
      return false;
    }
  }

  /** 計算一般問卷填寫者年齡 */
  計算年齡() {
    if (this.common_date === "2999-01-01") {
      //未設定基準日
      return "";
    } else {
      let dayjs_birth_date = dayjs(this.birth_date);
      let dayjs_common_date = dayjs(this.common_date);

      if (dayjs_birth_date.isValid() !== true) {
        throw new_ErrorAlert("生日格式錯誤! " + this.serno);
      }

      if (dayjs_common_date.isValid() !== true) {
        throw new_ErrorAlert("基準日格式錯誤! " + this.serno);
      }

      if (dayjs_birth_date.year() === 2999) {
        throw new_ErrorAlert("生日尚未設定! " + this.serno);
      }

      if (dayjs_common_date.year() === 2999) {
        throw new_ErrorAlert("基準日尚未設定! " + this.serno);
      }

      if (dayjs_common_date.year() < dayjs_birth_date.year()) {
        throw new_ErrorAlert("基準日 應該在 生日之後! " + this.serno);
      }

      let age = dayjs_common_date.year() - dayjs_birth_date.year();
      console.log(
        "member:",
        this.serno + " " + this.member_name,
        "    基準日:",
        dayjs_common_date.format("YYYY-MM-DD"),
        "    生日:",
        dayjs_birth_date.format("YYYY-MM-DD"),
        "    年齡:",
        age
      );

      return age;
    }
  }

  計算年資_年() {
    if (this.common_date === "2999-01-01" || this.start_date === "2999-01-01") {
      //未設定基準日 or 開單時沒有到職日
      return "";
    } else {
      let start_date = this.start_date;
      let common_date = this.common_date;
      let year = dayjs(common_date).diff(dayjs(start_date), "year");
      return year;
    }
  }

  計算年資_月() {
    if (this.common_date === "2999-01-01" || this.start_date === "2999-01-01") {
      //未設定基準日 or 開單時沒有到職日
      return "";
    } else {
      let start_date = this.start_date;
      let common_date = this.common_date;
      let month = dayjs(common_date).diff(dayjs(start_date), "month");

      return month % 12;
    }
  }

  /**部門名稱 */
  department = "";
  /**到職日 */
  start_date = "2999-01-01";
  /**職稱 */
  job_title = "";

  /**
   * 預計體檢日
   */
  appointment_date = "2999-01-01";

  /**readonly 一般問卷基準日 */
  common_date = "2999-01-01";

  rec_dt = "2999-01-01 00:00:00";
  IsRecDt2999() {
    return !IsYear2999(this.rec_dt);
  }
  xls_spwk_done_status = "";

  xls_ui_done_status = "";

  dr_comment = "";

  constructor() {
    this.guid = uuid();
  }
}

function IsYear2999(dt_str: string) {
  if (dt_str == null || dt_str === "") {
    throw new_ErrorAlert("4646161 dt_str: 沒有填值 !!!");
  } else {
    return dayjs(dt_str).year() === 2999;
  }
}
